var $653a020875a8fea3$exports = {};
$653a020875a8fea3$exports = {
    "loading": `Loading\u{2026}`,
    "loadingMore": `Loading more\u{2026}`
};


export {$653a020875a8fea3$exports as default};
//# sourceMappingURL=en-US.module.js.map
